<div class="mobile-nav-menu d-flex position-fixed flex-column d-lg-none">
  <!-- NAV BAR -->
  <div class="mobile-nav-bar d-flex justify-content-between">
    <a class="nav-item fw-bold brand p-1" [routerLink]="['/']">
      <label id="homeLink" class="accessibility-only">Go To Home Page</label>
      <img alt="" class="home-logo" src="assets/images/club-logo.png" draggable="false" />
    </a>

    <button
      attr.aria-label="{{ 'nav.toggle.screenreader' | translate }}"
      class="nav-item fw-bold navbar-toggler m-0 px-2"
      (click)="isCollapsed = !isCollapsed"
    >
      <span class="icon material-icons material-mobile-nav">menu</span>
    </button>
  </div>

  <!-- NAV SCREEN -->
  <div [ngbCollapse]="isCollapsed" class="mobile-nav-menu-dropdown">
    <div class="d-flex flex-column mobile-nav-menu-content">
      <!-- Close Button -->
      <button
        class="close-button position-absolute border-0"
        attr.aria-label="{{ 'modal.close' | translate }}"
        (click)="isCollapsed = !isCollapsed"
      >
        <i class="material-icons close-btn">close</i>
      </button>
      <!-- Logo -->
      <div class="mobile-bar">
        <img alt="" class="logo px-2" src="assets/images/club-logo.png" draggable="false" />
      </div>

      <!-- Nav Buttons -->
      <div class="container mobile-nav-button-container">
        <ng-container *ngIf="memberDetails$ | async as memberDetails">
          <div class="member-info w-100">
            <div class="d-flex justify-content-between align-items-center">
              <!--Name and ID-->
              <div class="card-id text-start text-black">
                <h5 class="mb-1 card-name">{{ memberDetails.FirstName }} {{ memberDetails.Surname }}</h5>
                <div class="d-flex product-code mt-2 font-size-14">
                  {{ ('member.card.id' | translate) + ': ' + memberDetails.ExternalRefNumber }}
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ul *notInProductCode="productCode.NonRenewing" class="navbar-nav me-auto w-100" #greedyNav>
          <li class="nav-item" routerLink="/account">
            <span class="icon material-icons material-dropdown-icon" aria-hidden="true">account_circle</span>
            <a class="nav-text text-white">{{ 'nav.account' | translate }}</a>
          </li>
          <li class="nav-item" routerLink="/rewards">
            <span class="icon material-icons material-symbols-outlined">redeem</span>
            <a class="nav-text text-white">{{ 'nav.rewards' | translate }}</a>
          </li>

          <li class="nav-item" routerLink="/challenges">
            <span class="icon material-icons material-symbols-outlined">emoji_events</span>
            <a class="nav-text text-white">{{ 'nav.challenges' | translate }}</a>
          </li>

          <li class="nav-item" routerLink="/games">
            <span class="icon material-icons material-symbols-outlined">sports_esports</span>
            <a class="nav-text text-white">{{ 'nav.games' | translate }}</a>
          </li>
          <li class="nav-item" routerLink="/rewards/wallet">
            <span class="icon material-icons material-symbols-outlined">account_balance_wallet</span>
            <a class="nav-text text-white">{{ 'nav.wallet' | translate }}</a>
          </li>
          <li class="nav-item justify-content-between" (click)="isCollapsedNav = !isCollapsedNav">
            <div class="d-flex">
              <span class="icon material-icons material-dropdown-icon" aria-hidden="true">info</span>
              <div class="dropdown-link text-start">
                <span class="nav-text">{{ 'nav.help' | translate }}</span>
              </div>
            </div>
            <span
              [@expandAnimation]="isCollapsedNav ? 'close' : 'open'"
              class="icon material-icons material-dropdown-icon m-0"
              aria-hidden="true"
              >keyboard_arrow_down</span
            >
          </li>
          <ul class="sub-nav text-white" *ngIf="isCollapsedNav">
            <li class="nav-item nav-help-item">
              <a
                class="nav-link mx-2 p-0"
                [routerLink]="['/terms']"
                attr.aria-label="{{ 'nav.terms.screenreader' | translate : { fgbdefault: 'Move to terms page' } }}"
                >{{ 'nav.terms' | translate }}</a
              >
            </li>
            <li class="nav-item nav-help-item">
              <a
                class="nav-link mx-2 p-0"
                [routerLink]="['/faq']"
                attr.aria-label="{{ 'nav.faq.screenreader' | translate : { fgbdefault: 'Move to faq page' } }}"
                >{{ 'nav.faq' | translate }}</a
              >
            </li>
            <li class="nav-item nav-help-item">
              <a
                class="nav-link mx-2 p-0"
                [routerLink]="['/contact']"
                attr.aria-label="{{ 'nav.contact.us.screenreader' | translate : { fgbdefault: 'Move to contact us page' } }}"
                >{{ 'nav.contact.us' | translate }}</a
              >
            </li>
          </ul>
        </ul>

        <a class="logout-btn text-error cursor-pointer mt-auto" (click)="logout()">
          <i class="material-symbols-outlined material-icons me-2">logout</i>
          <span>{{ 'nav.log.out' | translate }}</span>
        </a>
      </div>
    </div>
  </div>
</div>
